import React from 'react';
import PropTypes from 'prop-types';
// react-mapbox-gl components

import withStyles from '@material-ui/core/styles/withStyles';

import { SpeedDial } from '@material-ui/lab';

class MapControlSpeedDial extends React.PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        label: PropTypes.string.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            isFixedOpen: false,
            isHoverOpen: false
        };
    }

    handleClick = () => {
        this.setState({
            isFixedOpen: !this.state.isFixedOpen
        });
    };

    handleClose = () => {
        this.setState({
            isHoverOpen: false
        });
    };

    handleOpen = () => {
        this.setState({
            isHoverOpen: true
        });
    };

    render () {
        const { classes, label, children, ...otherProps } = this.props;
        const { isFixedOpen, isHoverOpen } = this.state;
        return (
            <SpeedDial
                classes={{
                    root: classes.root,
                    fab: classes.fab,
                    actions: `${classes.actions} ${(isHoverOpen || isFixedOpen) ? classes.pointerEvents : ''}`
                }}
                FabProps={{
                    onClick: this.handleClick
                }}
                ariaLabel={label}
                direction="left"
                onClose={this.handleClose}
                onOpen={this.handleOpen}
                open={isFixedOpen || isHoverOpen}
                {...otherProps}
            >
                {children}
            </SpeedDial>
        );
    }
}

const style = theme => ({
    root: {
        width: theme.constants.mapButton,
        height: theme.constants.mapButton
    },
    fab: {
        ...theme.components.mapButton,
        minWidth: theme.constants.mapButton
    },
    actions: {
        pointerEvents: 'none !important',
        '& > *': {
            margin: theme.constants.horizontalMargin * 0.5,
            ...theme.components.mapButton
        }
    },
    pointerEvents: {
        pointerEvents: 'auto !important'
    }
});

export default withStyles(style)(MapControlSpeedDial);